import { useMemo } from "react";

import type { FilterOption } from "~/shared/section";

import { useGenerationSettings } from "./api";

/**
 * Модели как опции панели фильтров. Живёт у сущности, а не в каждом списочном
 * представлении: форма опции («id → имя модели») — свойство каталога моделей, и
 * четыре VM списков повторяли её дословно.
 */
export function useModelFilterOptions(): FilterOption[] {
    const { data } = useGenerationSettings();
    return useMemo(() => (data ?? []).map((m) => ({ value: m.id, label: m.name })), [data]);
}
